import React, { useState } from "react";
import { useHistory } from "react-router-dom";

const EmailForm = () => {
  const [email, setEmail] = useState("");
  const history = useHistory();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Alamat Email:
        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          required
        />
      </label>
      <button type="submit">Kirim</button>
    </form>
  );
};

export default EmailForm;
